module.exports = "<span v-text=\"value\"></span>\n";